import React from 'react';
interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  bgColor?: 'ivory' | 'sand';
  narrow?: boolean;
  id?: string;
}
export function SectionWrapper({
  children,
  className = '',
  bgColor = 'ivory',
  narrow = false,
  id
}: SectionWrapperProps) {
  const bgColors = {
    ivory: 'bg-ivory',
    sand: 'bg-sand'
  };
  return <section id={id} className={`w-full py-[60px] md:py-[100px] ${bgColors[bgColor]} ${className}`} data-id="element-147">
      <div className={`mx-auto px-6 ${narrow ? 'max-w-[680px]' : 'max-w-[1000px]'}`} data-id="element-148">
        {children}
      </div>
    </section>;
}